/**
*	@author Camilo
*	@since  03/11/2017
**/
export class FacturaModel{
	constructor(public id:MchPrefacturaId){}


}


export class MchPrefacturaId{
	constructor(public cid:string,
		public cnumcont:string, 
		public ciddoc:string, 
		public dfecmov:Date, 
		public cdescripcion:string, 
		public cusuario:string, 
		public dfecsist:string,
		public referencia4:string,
		public nestado:number,
		public ndiasvenc:number,
		public vtipomoneda:string,
		public trm:number,
		public vidEscritura:string
		){}
		
}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/CrearFactura/CrearFactura.model.ts